import 'datatables.net-dt';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-fixedcolumns';
import 'datatables.net-bs4';
import 'datatables.net-buttons-bs4';
import 'datatables.net-responsive-bs4';

const $ = require('jquery');

export const initDataTables = () => {
  $(document).ready(() => {
    const isEn = document.documentElement.lang === 'en';
    const dataTableTables = document.querySelectorAll('.datatable');
    if (dataTableTables) {
      dataTableTables.forEach((dataTablesTable, i) => {
        // Initiatialise DataTable.
        $(dataTablesTable).DataTable({
          // Refer to the complete list of language strings here:
          // https://datatables.net/reference/option/language
          // {
          //   'decimal':        ',
          //   'emptyTable':     'No data available in table',
          //   'info':           'Showing _START_ to _END_ of _TOTAL_ entries',
          //   'infoEmpty':      'Showing 0 to 0 of 0 entries',
          //   'infoFiltered':   '(filtered from _MAX_ total entries)',
          //   'infoPostFix':    ',
          //   'thousands':      ',',
          //   'lengthMenu':     'Show _MENU_ entries',
          //   'loadingRecords': 'Loading...',
          //   'processing':     ',
          //   'search':         'Search:',
          //   'zeroRecords':    'No matching records found',
          //   'paginate': {
          //       'first':      'First',
          //       'last':       'Last',
          //       'next':       'Next',
          //       'previous':   'Previous'
          //   },
          //   'aria': {
          //       'sortAscending':  ': activate to sort column ascending',
          //       'sortDescending': ': activate to sort column descending'
          //   }
          // }

          language: {
            lengthMenu: isEn ? 'Show _MENU_ entries' : 'Show _MENU_ entries',
            search: isEn ? 'Search' : 'Kimihia',
            info: isEn
              ? 'Showing _START_ to _END_ of _TOTAL_ entries'
              : 'Showing _START_ to _END_ of _TOTAL_ entries',
            infoEmpty: isEn ? 'Showing 0 to 0 of 0 entries' : 'Showing 0 to 0 of 0 entries',
            zeroRecords: isEn ? 'No results found for' : 'Kāore he putanga mō',
            paginate: {
              first: isEn ? 'First' : 'Te tuatahi',
              last: isEn ? 'Last' : 'Te whakamutunga',
              next: isEn ? 'Next' : 'Tō muri ake',
              previous: isEn ? 'Previous' : 'Tō mua atu',
            },
          },
          dom: 'Blrtip',
          buttons: ['print'],
          initComplete: () => {
            setTimeout(() => {
              $(dataTablesTable).addClass('datatable--initialised');
            }, 500);

            const dataTablesTableTheadTr = $(dataTablesTable).find('thead tr:last');
            const dataTablesTableTheadTrClone = dataTablesTableTheadTr
              .clone()
              .insertAfter(dataTablesTableTheadTr);
            dataTablesTableTheadTrClone.addClass('column-filtering');
            dataTablesTableTheadTrClone.addClass(`filters-${i}`);

            // Remove tabindex from each filtering column.
            const sortColThs = document.querySelectorAll('.column-filtering th');
            sortColThs.forEach((sortColTh) => {
              sortColTh.removeAttribute('tabindex');
            });

            // const api = this.api();
            const api = $(dataTablesTable).dataTable().api();

            // For each column
            api
              .columns()
              .eq(0)
              .each((colIdx) => {
                // Set the header cell to contain the input element
                const cell = $(`.filters-${i} th`).eq($(api.column(colIdx).header()).index());
                const title = $(cell).text();
                $(cell).html(`<input type="text" aria-label="Filter by ${title}" />`);

                // On every keypress in this input
                $('input', $(`.filters-${i} th`).eq($(api.column(colIdx).header()).index()))
                  .off('keyup change')

                  .on('change', function () {
                    // Get the search value
                    $(this).attr('title', $(this).val());
                    const regexr = '({search})';

                    // Search the column for that value
                    api
                      .column(colIdx)
                      .search(
                        this.value !== '' ? regexr.replace('{search}', `(((${this.value})))`) : '',
                        this.value !== '',
                        this.value === ''
                      )
                      .draw();
                  })

                  .on('keyup', function (e) {
                    e.stopPropagation();
                    $(this).trigger('change');
                  });
              });
          },
        });

        // Remove `aria-controls` attribute from pagination buttons as it breaks accessibility.
        const paginationLinks = document.querySelectorAll('.paginate_button .page-link');
        paginationLinks.forEach((paginationLink) => {
          paginationLink.removeAttribute('aria-role');
          paginationLink.setAttribute('role', 'link');
        });

        // Apply `expanded` or `expanded-wide` container treat or modifier for tables with
        // 'datatable--wide' modifier.
        const isExpandedDataTable = $(dataTablesTable).hasClass('datatable--expanded');
        const isExpandedWideDataTable = $(dataTablesTable).hasClass('datatable--expanded-wide');
        const dataTableWrapper = $(dataTablesTable).closest('.dataTables_wrapper');

        if (dataTableWrapper) {
          if (isExpandedDataTable) {
            dataTableWrapper.addClass('dataTables_wrapper--expanded');
          } else if (isExpandedWideDataTable) {
            dataTableWrapper.addClass('dataTables_wrapper--expanded-wide');
          }
        }
      });
    }
  });
};

export default 'initDataTables';
